import React from 'react';
import Country from '../10-prop-types/setup'
const Home = () => {
  return (
    <div className="container">
      <Country/>
    </div>
  );
};

export default Home;
